rhm.team = window.rhm.team || {};

// =include modules/rhm_team_products.js


rhm.team.init = (function (module) {
  var init = function () {
    rhm.team.settings = JSON.parse(document.getElementById('json_team').innerHTML);
    rhm.team.products.init();
  };
  return init;
}(window.rhm.team));

rhm.team.init();
document.dispatchEvent(new CustomEvent('loadGlobalDeferred'));
